module.exports = __webpack_public_path__ + "static/media/lobby.1ed15159.jpg";